/* angular:styles/component:css;a129193ffbe3abb2e7c259d33df2d07f400a64d3c126a225f481e04228685558;/app/frontend_mobile/src/app/components/divider/divider.component.ts */
.divider {
  margin: 8px;
  border-top-width: 2px;
  border-top-style: solid;
  border-color: #d5d5d5;
}
/*# sourceMappingURL=divider.component.css.map */
